/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SaleRequestFormViewModel,
    SaleRequestFormViewModelFromJSON,
    SaleRequestFormViewModelFromJSONTyped,
    SaleRequestFormViewModelToJSON,
} from './SaleRequestFormViewModel';

/**
 * 
 * @export
 * @interface SaleRequestFormViewModelPagedDataModel
 */
export interface SaleRequestFormViewModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormViewModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormViewModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormViewModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormViewModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormViewModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<SaleRequestFormViewModel>}
     * @memberof SaleRequestFormViewModelPagedDataModel
     */
    data?: Array<SaleRequestFormViewModel> | null;
}

export function SaleRequestFormViewModelPagedDataModelFromJSON(json: any): SaleRequestFormViewModelPagedDataModel {
    return SaleRequestFormViewModelPagedDataModelFromJSONTyped(json, false);
}

export function SaleRequestFormViewModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaleRequestFormViewModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(SaleRequestFormViewModelFromJSON)),
    };
}

export function SaleRequestFormViewModelPagedDataModelToJSON(value?: SaleRequestFormViewModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(SaleRequestFormViewModelToJSON)),
    };
}

